import React from "react";

export class AccessingView extends React.Component<{}, {}> {
    render() {
        return (<>
        <div className="text-center mw-100" style={{width: "834px", aspectRatio: "556/429" }}>
            <svg
                id="svg9699"
                version="1.1"
                viewBox="0 0 556 429">
                <defs
                    id="defs9703">
                    <linearGradient
                    xlinkHref="#linearGradient7498-0"
                    id="linearGradient9583"
                    gradientUnits="userSpaceOnUse"
                    x1="319.91"
                    y1="61.00069"
                    x2="342.3078"
                    y2="216.44496" />
                    <linearGradient
                    id="linearGradient7498-0">
                    <stop
                        stopColor="#000000" stopOpacity="1"
                        offset="0"
                        id="stop7500-4" />
                    <stop
                        stopColor="#0f0c7f" stopOpacity="0"
                        offset="1"
                        id="stop7502-2" />
                    </linearGradient>
                    <linearGradient

                        xlinkHref="#linearGradient7498-0"
                    id="linearGradient8835"
                    gradientUnits="userSpaceOnUse"
                    x1="319.91"
                    y1="61.00069"
                    x2="342.3078"
                    y2="216.44496" />
                    <linearGradient
                    id="linearGradient9728">
                    <stop
                        stopColor="#000000" stopOpacity="1"
                        offset="0"
                        id="stop9730" />
                    <stop
                        stopColor="#0f0c7f" stopOpacity="0"
                        offset="1"
                        id="stop9732" />
                    </linearGradient>
                </defs>
                <g
                    overflow="visible"
                    id="g9491"
                    transform="matrix(1.9956986,0,0,1.9956986,-257.11218,-102.29141)">
                    <g
                    transform="translate(-51.814757,10.90837)"
                    id="g6692"
                    fill="#000271" fillOpacity="1" stroke="#a3a1ac" strokeOpacity="1">
                    <path
                        fill= "#000271" fillOpacity="1" stroke="#a3a1ac" strokeWidth="2.14960003" strokeOpacity="1"
                        d="m 319.91,224.132 c -48.299,0 -87.455,-39.154 -87.455,-87.455 0,-48.301 39.156,-87.454 87.455,-87.454 48.301,0 87.455,39.155 87.455,87.454 0,48.301 -39.155,87.455 -87.455,87.455 z"
                        id="path6694" />
                    </g>
                    <g
                    id="g9394">
                    <path
                        id="path6696"
                        d="m 193.26624,82.13737 c 7.892,-6.473 16.893,-20.31 16.893,-20.31 0,0 -2.884,0.159 -6.729,2.273 -4.786,2.632 -10.741,7.333 -10.741,7.333 l 0.582,-5.822 c 0,0 -4.741,3.756 -7.768,8.729 -3.088,5.071 -4.46,11.36 -4.46,11.36 0,0 5.685,1.797 12.223,-3.563 z m -14.967,18.857 c 4.479,-4.053 7.694,-9.762 7.694,-9.762 0,0 -2.735,1.362 -5.283,1.773 -1.853,0.298 -3.742,-0.317 -3.742,-0.317 0,0 -0.983,-2.049 -0.785,-5.543 0.234,-4.162 1.658,-9.887 1.658,-9.887 0,0 -5.305,5.723 -7.599,12.605 -0.645,1.934 -1.126,3.942 -1.491,5.888 -1.405,6.548 -1.101,12.074 -1.101,12.074 0,0 5.961,-2.59 10.649,-6.831 z m -8.385,21.332 c 3.635,-4.006 5.888,-10.131 5.888,-10.131 0,0 -3.078,1.718 -6.243,2.449 -2.408,0.555 -5.11,0.172 -5.11,0.172 0,0 -0.847,-2.492 -1.185,-6.058 -0.601,-6.355 -0.272,-16.361 -0.272,-16.361 0,0 -5.477,9.954 -5.703,18.949 -0.209,8.3 4.249,16.569 4.249,16.569 0,0 4.882,-1.738 8.376,-5.589 z m -10.415,25.097 c 0,0 5.326,-4.017 8.2,-8.705 2.648,-4.321 2.863,-9.347 2.863,-9.347 0,0 -2.567,1.404 -5.3,2.467 -2.499,0.971 -5.181,1.609 -5.181,1.609 0,0 -2.973,-3.246 -4.799,-7.509 -2.773,-6.471 -4.81,-14.909 -4.81,-14.909 0,0 -2.943,11.298 -0.668,20.477 2.237,9.017 9.695,15.917 9.695,15.917 z m 1.456,22.126 c 0,0 3.673,-3.872 5.651,-8.749 2.094,-5.159 2.5,-11.34 2.5,-11.34 l -8.441,7.569 c 0,0 -4.536,-3.005 -8.433,-8.16 -5.335,-7.061 -10.491,-16.878 -10.491,-16.878 0,0 -0.65,15.365 4.191,24.829 4.765,9.314 15.023,12.729 15.023,12.729 z m 5.531,20.38 c 0,0 3.242,-3.754 4.261,-8.588 1.28,-6.084 0.398,-13.539 0.398,-13.539 0,0 -1.477,3.089 -3.359,5.913 -1.585,2.379 -3.627,4.568 -3.627,4.568 0,0 -5.294,-2.132 -10.464,-7.007 -7.273,-6.861 -15.448,-18.032 -15.448,-18.032 0,0 0.754,16.66 7.68,25.535 7.046,9.03 20.559,11.15 20.559,11.15 z m 11.355,19.506 c 0,0 1.972,-5.252 1.903,-11.063 -0.076,-6.391 -2.194,-13.394 -2.194,-13.394 l -6.697,12.81 c 0,0 -6.29,0.203 -12.571,-3.101 -7.694,-4.045 -15.668,-11.747 -15.668,-11.747 0,0 5.219,14.561 14.261,21.361 8.558,6.438 20.966,5.134 20.966,5.134 z m 13.683,16.887 c 0,0 0.928,-5.921 0.051,-11.314 -1.007,-6.195 -3.835,-11.977 -3.835,-11.977 0,0 -0.536,4.23 -1.805,8.035 -1.037,3.112 -2.854,5.939 -2.854,5.939 0,0 -3.589,0.529 -8.163,0.126 -6.562,-0.581 -14.837,-2.163 -14.837,-2.163 0,0 4.47,6.184 12.52,9.091 7.662,2.766 18.923,2.263 18.923,2.263 z m 6.405,-10.191 -1.164,14.848 c 0,0 -3.374,1.328 -7.871,1.513 -5.929,0.244 -13.384,-0.639 -13.384,-0.639 0,0 6.521,5.563 14.293,7.362 7.948,1.84 17.151,-0.083 17.151,-0.083 0,0 0.98,-5.251 -1.095,-10.271 -2.41,-5.835 -7.93,-12.73 -7.93,-12.73 z m 54.595,30.589 c -4.975,-2.746 -12.38,-4.387 -12.38,-4.387 0,0 -7.459,-1.217 -14.534,-3.28 -6.896,-2.013 -13.415,-4.871 -13.415,-4.871 0,0 1.464,3.644 0.677,6.162 -0.657,2.102 -3.588,3.153 -3.588,3.153 l 6.404,2.038 c 0,0 16.171,0.471 25.625,2.009 8.388,1.363 10.187,3.813 10.187,3.813 0,0 -1.023,1.077 -4.626,1.657 -5.144,0.83 -12.843,0.673 -12.843,0.673 l 5.53,5.241 c 0,0 6.063,0.739 11.299,-0.777 4.789,-1.388 8.791,-5.047 8.791,-5.047 0,0 -2.352,-3.747 -7.127,-6.384 z m 90.399,-164.583 c 6.537,5.36 12.223,3.563 12.223,3.563 0,0 -1.372,-6.289 -4.46,-11.361 -3.026,-4.972 -7.77,-8.729 -7.77,-8.729 l 0.582,5.822 c 0,0 -5.955,-4.702 -10.741,-7.333 -3.844,-2.115 -6.728,-2.273 -6.728,-2.273 0,0 9.001,13.839 16.894,20.311 z m 14.967,18.857 c 4.688,4.24 10.647,6.833 10.647,6.833 0,0 0.306,-5.52 -1.097,-12.063 -0.364,-1.95 -0.85,-3.964 -1.493,-5.9 -2.296,-6.883 -7.601,-12.605 -7.601,-12.605 0,0 1.422,5.726 1.658,9.888 0.197,3.495 -0.785,5.543 -0.785,5.543 0,0 -1.891,0.615 -3.742,0.317 -2.547,-0.412 -5.282,-1.773 -5.282,-1.773 0,0 3.214,5.708 7.695,9.76 z m 2.495,11.201 c 0,0 2.253,6.125 5.889,10.131 3.495,3.853 8.378,5.59 8.378,5.59 0,0 4.457,-8.27 4.249,-16.569 -0.229,-8.995 -5.704,-18.949 -5.704,-18.949 0,0 0.328,10.006 -0.272,16.361 -0.338,3.565 -1.184,6.057 -1.184,6.057 0,0 -2.703,0.384 -5.112,-0.172 -3.165,-0.731 -6.244,-2.449 -6.244,-2.449 z m 10.541,19.643 c -2.73,-1.063 -5.301,-2.467 -5.301,-2.467 0,0 0.216,5.024 2.864,9.347 2.874,4.688 8.2,8.705 8.2,8.705 0,0 7.457,-6.9 9.691,-15.917 2.275,-9.179 -0.668,-20.477 -0.668,-20.477 0,0 -2.035,8.438 -4.81,14.908 -1.827,4.264 -4.798,7.51 -4.798,7.51 0,0 -2.679,-0.638 -5.178,-1.609 z m 4.599,25.193 -8.443,-7.568 c 0,0 0.406,6.181 2.5,11.339 1.979,4.878 5.652,8.75 5.652,8.75 0,0 10.258,-3.416 15.021,-12.729 4.843,-9.464 4.193,-24.829 4.193,-24.829 0,0 -5.156,9.818 -10.492,16.878 -3.896,5.153 -8.431,8.159 -8.431,8.159 z m 6.969,14.246 c -5.171,4.876 -10.464,7.008 -10.464,7.008 0,0 -2.042,-2.19 -3.628,-4.568 -1.883,-2.823 -3.359,-5.913 -3.359,-5.913 0,0 -0.883,7.454 0.399,13.539 1.017,4.834 4.259,8.588 4.259,8.588 0,0 13.514,-2.121 20.562,-11.15 6.928,-8.874 7.68,-25.534 7.68,-25.534 0,0 -8.174,11.169 -15.449,18.03 z m -17.16,26.512 -6.696,-12.81 c 0,0 -2.116,7.002 -2.192,13.394 -0.069,5.81 1.901,11.063 1.901,11.063 0,0 12.408,1.304 20.968,-5.133 9.042,-6.801 14.262,-21.361 14.262,-21.361 0,0 -7.977,7.702 -15.668,11.747 -6.286,3.303 -12.575,3.1 -12.575,3.1 z m -12.227,19.215 c 0,0 -1.815,-2.827 -2.854,-5.939 -1.269,-3.805 -1.805,-8.035 -1.805,-8.035 0,0 -2.829,5.781 -3.835,11.977 -0.877,5.395 0.05,11.314 0.05,11.314 0,0 11.262,0.503 18.923,-2.264 8.051,-2.907 12.521,-9.091 12.521,-9.091 0,0 -8.277,1.581 -14.839,2.162 -4.573,0.406 -8.161,-0.124 -8.161,-0.124 z m -5.813,15.488 c -4.498,-0.186 -7.871,-1.513 -7.871,-1.513 l -1.165,-14.848 c 0,0 -5.52,6.894 -7.933,12.729 -2.075,5.021 -1.094,10.271 -1.094,10.271 0,0 9.202,1.925 17.149,0.083 7.772,-1.8 14.293,-7.362 14.293,-7.362 0,0 -7.45,0.884 -13.379,0.64 z m -23.978,7.852 c -0.787,-2.521 0.677,-6.161 0.677,-6.161 0,0 -6.519,2.858 -13.415,4.87 -7.076,2.063 -14.534,3.28 -14.534,3.28 0,0 -7.405,1.64 -12.378,4.387 -4.775,2.637 -7.128,6.387 -7.128,6.387 0,0 4.003,3.658 8.79,5.046 5.236,1.519 11.299,0.777 11.299,0.777 l 5.531,-5.241 c 0,0 -7.699,0.158 -12.843,-0.671 -3.603,-0.582 -4.625,-1.658 -4.625,-1.658 0,0 1.798,-2.45 10.186,-3.813 9.454,-1.538 25.624,-2.009 25.624,-2.009 l 6.405,-2.038 c -10e-4,-0.002 -2.932,-1.054 -3.589,-3.156 z"
                        fill="#a3a1ac" fillOpacity="1" fillRule="nonzero" />
                    <g
                        fill="url(#linearGradient9583)" fillOpacity="1" stroke="#a3a1ac" strokeOpacity="1" overflow="visible"
                        id="g6692-7"
                        transform="translate(-51.973167,10.244601)">
                        <path
                        id="path6694-3"
                        d="m 319.91,224.132 c -48.299,0 -87.455,-39.154 -87.455,-87.455 0,-48.301 39.156,-87.454 87.455,-87.454 48.301,0 87.455,39.155 87.455,87.454 0,48.301 -39.155,87.455 -87.455,87.455 z"
                        fill="url(#linearGradient8835)" fillOpacity="1" stroke="#a3a1ac" strokeWidth="2.14960003" strokeOpacity="1" />
                    </g>
                    <g
                        id="g7856-7-8"
                        overflow="visible"
                        transform="translate(-51.745271,10.045579)">
                        <path
                        fill="#ffffff"
                        d="m 316.675,139.02 c 0.003,0 0.004,0 0.004,0 h -0.007 c -0.354,-0.006 -16.407,-0.262 -19.06,-2.913 -2.651,-2.651 -2.907,-18.705 -2.912,-19.059 v -0.007 c 0,0 0,0.001 0,0.004 0,-0.003 0,-0.004 0,-0.004 v 0.007 c -0.006,0.354 -0.261,16.407 -2.913,19.059 -2.637,2.638 -18.537,2.905 -19.051,2.913 h -0.013 c 0,0 0.003,0 0.007,0 -0.004,0 -0.007,0 -0.007,0 h 0.013 c 0.515,0.007 16.414,0.275 19.051,2.912 2.652,2.651 2.907,18.705 2.913,19.059 v 0.007 c 0,0 0,-10e-4 0,-0.004 0,0.002 0,0.004 0,0.004 v -0.007 c 0.006,-0.354 0.261,-16.406 2.913,-19.059 2.651,-2.651 18.705,-2.907 19.059,-2.912 h 0.007 c -10e-4,0 -0.002,0 -0.004,0 z"
                        id="path6698-0-3" />
                        <path
                        fill="#ffffff"
                        d="m 353.525,113.174 c 0.002,0 0.003,0 0.003,0 h -0.006 c -0.272,-0.004 -12.656,-0.2 -14.701,-2.246 -2.045,-2.046 -2.242,-14.429 -2.247,-14.7 v -0.004 c 0,0 0,0 0,0.002 0,-0.001 0,-0.002 0,-0.002 v 0.004 c -0.004,0.271 -0.201,12.654 -2.245,14.7 -2.034,2.034 -14.299,2.24 -14.696,2.246 h -0.011 c 0,0 0.003,0 0.007,0 -0.004,0 -0.007,0 -0.007,0 h 0.011 c 0.397,0.007 12.662,0.212 14.696,2.247 2.045,2.045 2.242,14.43 2.245,14.701 v 0.006 c 0,0 0,-10e-4 0,-0.003 0,0.002 0,0.003 0,0.003 v -0.006 c 0.005,-0.271 0.202,-12.656 2.248,-14.701 2.045,-2.045 14.428,-2.243 14.7,-2.247 h 0.006 c -0.001,0 -0.002,0 -0.003,0 z"
                        id="path6700-2-1" />
                        <path
                        fill="#ffffff"
                        d="m 361.284,157.443 c 0.001,0 0.003,0 0.003,0 h -0.006 c -0.253,-0.004 -11.813,-0.189 -13.722,-2.097 -1.91,-1.909 -2.094,-13.469 -2.098,-13.724 v -0.005 c 0,0 0,0.001 0,0.003 0,-0.001 0,-0.003 0,-0.003 v 0.005 c -0.005,0.254 -0.188,11.813 -2.098,13.723 -1.898,1.898 -13.347,2.092 -13.717,2.098 h -0.01 c 0,0 0.002,0 0.005,0 -0.003,0 -0.005,0 -0.005,0 h 0.01 c 0.37,0.007 11.818,0.199 13.717,2.097 1.91,1.91 2.094,13.469 2.098,13.723 v 0.006 c 0,0 0,0 0,-0.002 0,0.001 0,0.002 0,0.002 v -0.006 c 0.005,-0.253 0.188,-11.813 2.098,-13.723 1.909,-1.909 13.469,-2.093 13.722,-2.097 h 0.006 c 0,0 -0.002,0 -0.003,0 z"
                        id="path6702-4-4" />
                        <circle
                        fill="#ffffff"
                        cx="347.91901"
                        cy="136.19701"
                        r="3.6760001"
                        id="circle6704-1-3"
                        d="m 351.59501,136.19701 c 0,2.0302 -1.6458,3.676 -3.676,3.676 -2.0302,0 -3.676,-1.6458 -3.676,-3.676 0,-2.0302 1.6458,-3.676 3.676,-3.676 2.0302,0 3.676,1.6458 3.676,3.676 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="326.039"
                        cy="150.31"
                        r="3.6760001"
                        id="circle6706-0-1"
                        d="m 329.715,150.31 c 0,2.0302 -1.6458,3.676 -3.676,3.676 -2.0302,0 -3.676,-1.6458 -3.676,-3.676 0,-2.0302 1.6458,-3.676 3.676,-3.676 2.0302,0 3.676,1.6458 3.676,3.676 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="301.84399"
                        cy="176.746"
                        r="3.6760001"
                        id="circle6708-3-0"
                        d="m 305.51999,176.746 c 0,2.0302 -1.6458,3.676 -3.676,3.676 -2.03019,0 -3.676,-1.6458 -3.676,-3.676 0,-2.0302 1.64581,-3.676 3.676,-3.676 2.0302,0 3.676,1.6458 3.676,3.676 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="319.91501"
                        cy="127.409"
                        r="3.415"
                        id="circle6710-7-4"
                        d="m 323.33001,127.409 c 0,1.88605 -1.52895,3.415 -3.415,3.415 -1.88605,0 -3.415,-1.52895 -3.415,-3.415 0,-1.88606 1.52895,-3.415 3.415,-3.415 1.88605,0 3.415,1.52894 3.415,3.415 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="320.11899"
                        cy="169.431"
                        r="3.6270001"
                        id="circle6712-3-0"
                        d="m 323.74599,169.431 c 0,2.00314 -1.62387,3.627 -3.627,3.627 -2.00314,0 -3.627,-1.62386 -3.627,-3.627 0,-2.00314 1.62386,-3.627 3.627,-3.627 2.00313,0 3.627,1.62386 3.627,3.627 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="271.82401"
                        cy="171.966"
                        r="3.6760001"
                        id="circle6714-9-7"
                        d="m 275.50001,171.966 c 0,2.0302 -1.64581,3.676 -3.676,3.676 -2.0302,0 -3.676,-1.6458 -3.676,-3.676 0,-2.0302 1.6458,-3.676 3.676,-3.676 2.03019,0 3.676,1.6458 3.676,3.676 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="388.09201"
                        cy="107.809"
                        r="3.6760001"
                        id="circle6716-5-9"
                        d="m 391.76801,107.809 c 0,2.0302 -1.6458,3.676 -3.676,3.676 -2.0302,0 -3.676,-1.6458 -3.676,-3.676 0,-2.0302 1.6458,-3.676 3.676,-3.676 2.0302,0 3.676,1.6458 3.676,3.676 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="368.008"
                        cy="100.078"
                        r="3.7090001"
                        id="circle6718-9-0"
                        d="m 371.717,100.078 c 0,2.04843 -1.66058,3.709 -3.709,3.709 -2.04843,0 -3.709,-1.66057 -3.709,-3.709 0,-2.048421 1.66057,-3.708997 3.709,-3.708997 2.04842,0 3.709,1.660576 3.709,3.708997 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="319.46799"
                        cy="137.61501"
                        r="2.697"
                        id="circle6720-7-8"
                        d="m 322.16499,137.61501 c 0,1.48951 -1.20749,2.697 -2.697,2.697 -1.48951,0 -2.697,-1.20749 -2.697,-2.697 0,-1.48952 1.20749,-2.697 2.697,-2.697 1.48951,0 2.697,1.20748 2.697,2.697 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="282.62701"
                        cy="170.373"
                        r="2.697"
                        id="circle6722-2-1"
                        d="m 285.32401,170.373 c 0,1.48951 -1.20748,2.697 -2.697,2.697 -1.48951,0 -2.697,-1.20749 -2.697,-2.697 0,-1.48951 1.20749,-2.697 2.697,-2.697 1.48952,0 2.697,1.20749 2.697,2.697 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="251.46201"
                        cy="157.33099"
                        r="2.697"
                        id="circle6724-0-4"
                        d="m 254.15901,157.33099 c 0,1.48952 -1.20749,2.697 -2.697,2.697 -1.48952,0 -2.697,-1.20748 -2.697,-2.697 0,-1.48951 1.20748,-2.697 2.697,-2.697 1.48951,0 2.697,1.20749 2.697,2.697 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="331.26501"
                        cy="68.166"
                        r="2.697"
                        id="circle6726-2-0"
                        d="m 333.96201,68.166 c 0,1.489512 -1.20748,2.697 -2.697,2.697 -1.48951,0 -2.697,-1.207488 -2.697,-2.697 0,-1.489512 1.20749,-2.697 2.697,-2.697 1.48952,0 2.697,1.207488 2.697,2.697 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="345.63901"
                        cy="65.969002"
                        r="2.697"
                        id="circle6728-8-7"
                        d="m 348.33601,65.969002 c 0,1.489512 -1.20749,2.697 -2.697,2.697 -1.48951,0 -2.697,-1.207488 -2.697,-2.697 0,-1.489512 1.20749,-2.697 2.697,-2.697 1.48951,0 2.697,1.207488 2.697,2.697 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="256.21399"
                        cy="127.479"
                        r="2.9790001"
                        id="circle6730-6-9"
                        d="m 259.19299,127.479 c 0,1.64525 -1.33374,2.979 -2.979,2.979 -1.64526,0 -2.979,-1.33375 -2.979,-2.979 0,-1.64526 1.33374,-2.979 2.979,-2.979 1.64526,0 2.979,1.33374 2.979,2.979 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="250.233"
                        cy="148.636"
                        r="2.9779999"
                        id="circle6732-7-5"
                        d="m 253.211,148.636 c 0,1.64471 -1.33329,2.978 -2.978,2.978 -1.6447,0 -2.978,-1.33329 -2.978,-2.978 0,-1.6447 1.3333,-2.978 2.978,-2.978 1.64471,0 2.978,1.3333 2.978,2.978 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="304.11801"
                        cy="94.750999"
                        r="2.9790001"
                        id="circle6734-0-3"
                        d="m 307.09701,94.750999 c 0,1.645257 -1.33374,2.979001 -2.979,2.979001 -1.64525,0 -2.979,-1.333744 -2.979,-2.979001 0,-1.645256 1.33375,-2.979 2.979,-2.979 1.64526,0 2.979,1.333744 2.979,2.979 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="291.237"
                        cy="95.628998"
                        r="2.0179999"
                        id="circle6736-8-8"
                        d="m 293.255,95.628998 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.114511 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.903489 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="315.11801"
                        cy="83.972"
                        r="2.0179999"
                        id="circle6738-1-2"
                        d="m 317.13601,83.972 c 0,1.114511 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.903489 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="320.29599"
                        cy="117.625"
                        r="2.0179999"
                        id="circle6740-8-3"
                        d="m 322.31399,117.625 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="300.39999"
                        cy="128.804"
                        r="2.0179999"
                        id="circle6742-3-2"
                        d="m 302.41799,128.804 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="309.013"
                        cy="145.731"
                        r="2.0190001"
                        id="circle6744-0-1"
                        d="m 311.032,145.731 c 0,1.11507 -0.90394,2.019 -2.019,2.019 -1.11506,0 -2.019,-0.90393 -2.019,-2.019 0,-1.11506 0.90394,-2.019 2.019,-2.019 1.11506,0 2.019,0.90394 2.019,2.019 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="312.448"
                        cy="162.657"
                        r="2.0179999"
                        id="circle6746-3-0"
                        d="m 314.466,162.657 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="312.74701"
                        cy="151.705"
                        r="2.0190001"
                        id="circle6748-6-4"
                        d="m 314.76601,151.705 c 0,1.11506 -0.90394,2.019 -2.019,2.019 -1.11506,0 -2.019,-0.90394 -2.019,-2.019 0,-1.11506 0.90394,-2.019 2.019,-2.019 1.11506,0 2.019,0.90394 2.019,2.019 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="320.11401"
                        cy="154.09399"
                        r="2.0179999"
                        id="circle6750-2-0"
                        d="m 322.13201,154.09399 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="349.04001"
                        cy="146.12801"
                        r="2.0179999"
                        id="circle6752-0-7"
                        d="m 351.05801,146.12801 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <path
                        fill="#ffffff"
                        d="m 339.284,150.883 c 0,1.114 -0.903,2.019 -2.019,2.019 -1.116,0 -2.019,-0.903 -2.019,-2.019 0,-1.114 0.902,-2.019 2.019,-2.019 1.115,0 2.019,0.904 2.019,2.019 z"
                        id="path6754-2-5" />
                        <circle
                        fill="#ffffff"
                        cx="362.332"
                        cy="124.622"
                        r="2.0179999"
                        id="circle6756-8-9"
                        d="m 364.35,124.622 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="320.91101"
                        cy="144.63499"
                        r="2.0190001"
                        id="circle6758-4-0"
                        d="m 322.93001,144.63499 c 0,1.11507 -0.90394,2.019 -2.019,2.019 -1.11506,0 -2.019,-0.90393 -2.019,-2.019 0,-1.11506 0.90394,-2.019 2.019,-2.019 1.11506,0 2.019,0.90394 2.019,2.019 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="330.66901"
                        cy="161.064"
                        r="2.0179999"
                        id="circle6760-1-5"
                        d="m 332.68701,161.064 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11452 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90348 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="367.70901"
                        cy="125.816"
                        r="2.0190001"
                        id="circle6762-8-1"
                        d="m 369.72801,125.816 c 0,1.11506 -0.90393,2.019 -2.019,2.019 -1.11506,0 -2.019,-0.90394 -2.019,-2.019 0,-1.11506 0.90394,-2.019 2.019,-2.019 1.11507,0 2.019,0.90394 2.019,2.019 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="383.63901"
                        cy="115.212"
                        r="2.0179999"
                        id="circle6764-3-2"
                        d="m 385.65701,115.212 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <path
                        fill="#ffffff"
                        d="m 385.658,142.558 c 0,1.271 -1.031,2.303 -2.303,2.303 -1.273,0 -2.305,-1.031 -2.305,-2.303 0,-1.273 1.031,-2.306 2.305,-2.306 1.27,0.002 2.303,1.034 2.303,2.306 z"
                        id="path6766-7-0" />
                        <circle
                        fill="#ffffff"
                        cx="359.14499"
                        cy="108.89"
                        r="2.0179999"
                        id="circle6768-5-9"
                        d="m 361.16299,108.89 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="371.89001"
                        cy="105.206"
                        r="2.0179999"
                        id="circle6770-8-8"
                        d="m 373.90801,105.206 c 0,1.11451 -0.90348,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11452,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="373.534"
                        cy="111.479"
                        r="2.0179999"
                        id="circle6772-1-9"
                        d="m 375.552,111.479 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="362.53101"
                        cy="90.569"
                        r="2.0190001"
                        id="circle6774-7-1"
                        d="m 364.55001,90.569 c 0,1.115063 -0.90394,2.019 -2.019,2.019 -1.11507,0 -2.019,-0.903937 -2.019,-2.019 0,-1.115063 0.90393,-2.019 2.019,-2.019 1.11506,0 2.019,0.903937 2.019,2.019 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="376.07199"
                        cy="95.348999"
                        r="2.0179999"
                        id="circle6776-0-7"
                        d="m 378.08999,95.348999 c 0,1.114511 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.903489 -2.018,-2.018 0,-1.114511 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.903489 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="368.008"
                        cy="80.014999"
                        r="2.0179999"
                        id="circle6778-4-3"
                        d="m 370.026,80.014999 c 0,1.114511 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.903489 -2.018,-2.018 0,-1.11451 0.90349,-2.017999 2.018,-2.017999 1.11451,0 2.018,0.903489 2.018,2.017999 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="299.604"
                        cy="155.09"
                        r="2.0190001"
                        id="circle6780-8-3"
                        d="m 301.623,155.09 c 0,1.11506 -0.90393,2.019 -2.019,2.019 -1.11506,0 -2.019,-0.90394 -2.019,-2.019 0,-1.11507 0.90394,-2.019 2.019,-2.019 1.11507,0 2.019,0.90393 2.019,2.019 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="297.91101"
                        cy="169.826"
                        r="2.0190001"
                        id="circle6782-8-0"
                        d="m 299.93001,169.826 c 0,1.11507 -0.90394,2.019 -2.019,2.019 -1.11506,0 -2.019,-0.90393 -2.019,-2.019 0,-1.11506 0.90394,-2.019 2.019,-2.019 1.11506,0 2.019,0.90394 2.019,2.019 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="288.452"
                        cy="172.713"
                        r="2.0190001"
                        id="circle6784-1-7"
                        d="m 290.471,172.713 c 0,1.11506 -0.90394,2.019 -2.019,2.019 -1.11507,0 -2.019,-0.90394 -2.019,-2.019 0,-1.11507 0.90393,-2.019 2.019,-2.019 1.11506,0 2.019,0.90393 2.019,2.019 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="284.07101"
                        cy="160.765"
                        r="2.0179999"
                        id="circle6786-3-6"
                        d="m 286.08901,160.765 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="291.33899"
                        cy="160.76601"
                        r="2.0179999"
                        id="circle6788-6-6"
                        d="m 293.35699,160.76601 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="273.716"
                        cy="153.696"
                        r="2.0179999"
                        id="circle6790-7-0"
                        d="m 275.734,153.696 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="280.33701"
                        cy="142.694"
                        r="2.0179999"
                        id="circle6792-8-2"
                        d="m 282.35501,142.694 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="267.34299"
                        cy="136.271"
                        r="2.0179999"
                        id="circle6794-9-8"
                        d="m 269.36099,136.271 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="250.019"
                        cy="114.615"
                        r="2.0179999"
                        id="circle6796-5-9"
                        d="m 252.037,114.615 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="255.125"
                        cy="174.29201"
                        r="2.0179999"
                        id="circle6798-5-8"
                        d="m 257.143,174.29201 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="268.14001"
                        cy="186.006"
                        r="2.0179999"
                        id="circle6800-5-9"
                        d="m 270.15801,186.006 c 0,1.11451 -0.90348,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11452,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="279.89001"
                        cy="176.44701"
                        r="2.0179999"
                        id="circle6802-6-9"
                        d="m 281.90801,176.44701 c 0,1.11451 -0.90348,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11452,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="331.26501"
                        cy="210.599"
                        r="2.0179999"
                        id="circle6804-6-9"
                        d="m 333.28301,210.599 c 0,1.11451 -0.90348,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11452,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="274.513"
                        cy="187.151"
                        r="2.0179999"
                        id="circle6806-3-4"
                        d="m 276.531,187.151 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="276.703"
                        cy="198.25301"
                        r="2.0179999"
                        id="circle6808-0-2"
                        d="m 278.721,198.25301 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="288.05399"
                        cy="189.53999"
                        r="2.0179999"
                        id="circle6810-0-0"
                        d="m 290.07199,189.53999 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="327.88101"
                        cy="193.424"
                        r="2.0179999"
                        id="circle6812-8-8"
                        d="m 329.89901,193.424 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="330.96799"
                        cy="180.28101"
                        r="2.0179999"
                        id="circle6814-8-7"
                        d="m 332.98599,180.28101 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="375.62399"
                        cy="182.073"
                        r="2.0179999"
                        id="circle6816-2-8"
                        d="m 377.64199,182.073 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="365.46899"
                        cy="150.60899"
                        r="2.0179999"
                        id="circle6818-3-7"
                        d="m 367.48699,150.60899 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="357.25699"
                        cy="140.00301"
                        r="2.2060001"
                        id="circle6820-0-3"
                        d="m 359.46299,140.00301 c 0,1.21834 -0.98766,2.206 -2.206,2.206 -1.21834,0 -2.206,-0.98766 -2.206,-2.206 0,-1.21834 0.98766,-2.206 2.206,-2.206 1.21834,0 2.206,0.98766 2.206,2.206 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="353.08499"
                        cy="132.55"
                        r="2.155"
                        id="circle6822-6-0"
                        d="m 355.23999,132.55 c 0,1.19018 -0.96482,2.155 -2.155,2.155 -1.19017,0 -2.155,-0.96482 -2.155,-2.155 0,-1.19017 0.96483,-2.155 2.155,-2.155 1.19018,0 2.155,0.96483 2.155,2.155 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="332.72101"
                        cy="134.739"
                        r="2.279"
                        id="circle6824-5-7"
                        d="m 335.00001,134.739 c 0,1.25866 -1.02034,2.279 -2.279,2.279 -1.25866,0 -2.279,-1.02034 -2.279,-2.279 0,-1.25866 1.02034,-2.279 2.279,-2.279 1.25866,0 2.279,1.02034 2.279,2.279 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="350.34399"
                        cy="108.453"
                        r="2.279"
                        id="circle6826-0-6"
                        d="m 352.62299,108.453 c 0,1.25866 -1.02034,2.279 -2.279,2.279 -1.25865,0 -2.279,-1.02034 -2.279,-2.279 0,-1.25865 1.02035,-2.279 2.279,-2.279 1.25866,0 2.279,1.02035 2.279,2.279 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="345.604"
                        cy="119.544"
                        r="2.3529999"
                        id="circle6828-9-4"
                        d="m 347.957,119.544 c 0,1.29952 -1.05347,2.353 -2.353,2.353 -1.29952,0 -2.353,-1.05348 -2.353,-2.353 0,-1.29953 1.05348,-2.353 2.353,-2.353 1.29953,0 2.353,1.05347 2.353,2.353 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="323.5"
                        cy="190.03799"
                        r="2.0179999"
                        id="circle6830-7-2"
                        d="m 325.518,190.03799 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="335.448"
                        cy="177.293"
                        r="2.0179999"
                        id="circle6832-2-1"
                        d="m 337.466,177.293 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="367.11099"
                        cy="113.57"
                        r="2.0179999"
                        id="circle6834-2-9"
                        d="m 369.12899,113.57 c 0,1.11451 -0.90349,2.018 -2.018,2.018 -1.11451,0 -2.018,-0.90349 -2.018,-2.018 0,-1.11451 0.90349,-2.018 2.018,-2.018 1.11451,0 2.018,0.90349 2.018,2.018 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="352.80099"
                        cy="117.878"
                        r="2.1900001"
                        id="circle6836-8-1"
                        d="m 354.99099,117.878 c 0,1.2095 -0.98049,2.19 -2.19,2.19 -1.2095,0 -2.19,-0.9805 -2.19,-2.19 0,-1.20951 0.9805,-2.19 2.19,-2.19 1.20951,0 2.19,0.98049 2.19,2.19 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="277.89801"
                        cy="93.406998"
                        r="2.697"
                        id="circle6838-2-6"
                        d="m 280.59501,93.406998 c 0,1.489512 -1.20749,2.697 -2.697,2.697 -1.48951,0 -2.697,-1.207488 -2.697,-2.697 0,-1.489512 1.20749,-2.697 2.697,-2.697 1.48951,0 2.697,1.207488 2.697,2.697 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="328.478"
                        cy="175.252"
                        r="2.697"
                        id="circle6840-9-0"
                        d="m 331.175,175.252 c 0,1.48951 -1.20749,2.697 -2.697,2.697 -1.48952,0 -2.697,-1.20749 -2.697,-2.697 0,-1.48951 1.20748,-2.697 2.697,-2.697 1.48951,0 2.697,1.20749 2.697,2.697 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="336.19501"
                        cy="188.545"
                        r="2.697"
                        id="circle6842-4-3"
                        d="m 338.89201,188.545 c 0,1.48951 -1.20749,2.697 -2.697,2.697 -1.48951,0 -2.697,-1.20749 -2.697,-2.697 0,-1.48951 1.20749,-2.697 2.697,-2.697 1.48951,0 2.697,1.20749 2.697,2.697 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="292.883"
                        cy="191.53101"
                        r="2.697"
                        id="circle6844-4-3"
                        d="m 295.58,191.53101 c 0,1.48951 -1.20749,2.697 -2.697,2.697 -1.48952,0 -2.697,-1.20749 -2.697,-2.697 0,-1.48952 1.20748,-2.697 2.697,-2.697 1.48951,0 2.697,1.20748 2.697,2.697 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="291.63599"
                        cy="183.76199"
                        r="2.8940001"
                        id="circle6846-8-6"
                        d="m 294.52999,183.76199 c 0,1.59832 -1.29569,2.894 -2.894,2.894 -1.59832,0 -2.894,-1.29568 -2.894,-2.894 0,-1.59831 1.29568,-2.894 2.894,-2.894 1.59831,0 2.894,1.29569 2.894,2.894 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="291.51999"
                        cy="68.283997"
                        r="2.977"
                        id="circle6848-2-2"
                        d="m 294.49699,68.283997 c 0,1.644151 -1.33285,2.977 -2.977,2.977 -1.64415,0 -2.977,-1.332849 -2.977,-2.977 0,-1.644152 1.33285,-2.977 2.977,-2.977 1.64415,0 2.977,1.332848 2.977,2.977 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="355.61099"
                        cy="123.626"
                        r="2.9779999"
                        id="circle6850-7-2"
                        d="m 358.58899,123.626 c 0,1.6447 -1.33329,2.978 -2.978,2.978 -1.6447,0 -2.978,-1.3333 -2.978,-2.978 0,-1.6447 1.3333,-2.978 2.978,-2.978 1.64471,0 2.978,1.3333 2.978,2.978 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="379.65701"
                        cy="120.888"
                        r="2.977"
                        id="circle6852-2-1"
                        d="m 382.63401,120.888 c 0,1.64415 -1.33285,2.977 -2.977,2.977 -1.64415,0 -2.977,-1.33285 -2.977,-2.977 0,-1.64415 1.33285,-2.977 2.977,-2.977 1.64415,0 2.977,1.33285 2.977,2.977 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="388.01999"
                        cy="161.811"
                        r="2.977"
                        id="circle6854-5-4"
                        d="m 390.99699,161.811 c 0,1.64416 -1.33285,2.977 -2.977,2.977 -1.64415,0 -2.977,-1.33284 -2.977,-2.977 0,-1.64415 1.33285,-2.977 2.977,-2.977 1.64415,0 2.977,1.33285 2.977,2.977 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="389.81299"
                        cy="126.414"
                        r="2.9779999"
                        id="circle6856-8-3"
                        d="m 392.79099,126.414 c 0,1.64471 -1.3333,2.978 -2.978,2.978 -1.64471,0 -2.978,-1.33329 -2.978,-2.978 0,-1.6447 1.33329,-2.978 2.978,-2.978 1.6447,0 2.978,1.3333 2.978,2.978 z"
                        />
                        <circle
                        fill="#ffffff"
                        cx="337.76199"
                        cy="139.183"
                        r="2.697"
                        id="circle6858-4-2"
                        d="m 340.45899,139.183 c 0,1.48951 -1.20748,2.697 -2.697,2.697 -1.48951,0 -2.697,-1.20749 -2.697,-2.697 0,-1.48951 1.20749,-2.697 2.697,-2.697 1.48952,0 2.697,1.20749 2.697,2.697 z"
                        />
                    </g>
                    <g
                        id="g8842"
                        fill="#a3a1ac" fillOpacity="1" stroke="none" overflow="visible"
                        transform="translate(-51.58646,10.243602)">
                        <path
                        id="path8844"
                        d="m 319.909,53.33 c -46.031,0 -83.348,37.316 -83.348,83.348 0,46.032 37.316,83.349 83.348,83.349 46.032,0 83.349,-37.316 83.349,-83.35 C 403.257,90.646 365.941,53.33 319.909,53.33 z m 0,162.626 c -43.783,0 -79.277,-35.494 -79.277,-79.278 0,-43.783 35.495,-79.277 79.277,-79.277 43.784,0 79.278,35.495 79.278,79.277 0,43.783 -35.494,79.278 -79.278,79.278 z"
                        fill="#a3a1ac" fillOpacity="1" stroke="none" />
                    </g>
                    </g>
                </g>
                </svg>
            </div>

            <p className="text-center my-5" style={{fontFamily: "lcars", fontSize: "64px", width: "834px", maxWidth: "100%"}}>ACCESSING...</p>
        </>)
    }
}